import React from 'react';

import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';

import shared from '~/styles/landingPageShared.module.less';
import imageSectionCSS from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

const text = (
  <div className={imageSectionCSS.dek}>
    These little touches delight guests and make the whole process feel more personal.
  </div>
);
const image = (
  <>
    <div className={css.sectionImage2}>
      <span role="img" aria-label="image of a personal dog photo" />
    </div>
    {renderAsBackgroundImage({
      selector: `.${css.sectionImage2}`,
      backgroundImageName: 'add',
      directory: 'CashGiftsLP/imageSections',
      filetype: ['png', 'png', 'png'],
      notVersioned: true,
    })}
  </>
);

/* ------------------------------------------------------------ */
const AddPhotosImageSection: React.FC = () => (
  <ImageSection
    backgroundColor={bgColorOption.lightGray}
    className={shared.borderBottom}
    headerTag="h2"
    textPosition="left"
    title="Add Photos and Notes"
    imageContents={image}
    secondaryContents={text}
  />
);

export default AddPhotosImageSection;
